import * as React from 'react'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { configurations } from '../../api'
import QRCodeWidgetCreator from './QRCodeWidgetCreator'
import QRCodeEdit from './QRCodeEdit'
import ModalWrapper from 'components/ModalWrapper'
import { getStaticImage } from 'utils/statics'

const QRCodeCreatorModal = (props) => {
  const { channels, onDataQRToWidget, dataCloneWebWidgetToQr, onClose } = props
  const qrPostersApi = configurations.channels
  const [currentTab, setCurrentTab] = React.useState(0)
  const [qrPosters, setQrPosters] = React.useState([])

  React.useEffect(() => {
    if (dataCloneWebWidgetToQr) {
      setCurrentTab(0)
    }
  }, [dataCloneWebWidgetToQr])

  const handleCurrentTab = (idx) => {
    setCurrentTab(idx)
  }

  const getAllQrPosterExternal = async () => {
    try {
      const result = await qrPostersApi.getAllQRPoster()
      if (result.data.length) {
        setQrPosters(result.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const tabs = [
    {
      name: I18n.t('channels_qr_new'),
      body: <QRCodeWidgetCreator key='QRCodeCreator' channels={channels} dataCloneWebWidgetToQr={dataCloneWebWidgetToQr} />
    },
    {
      name: I18n.t('channels_qr_edit'),
      body: <QRCodeEdit
        key='QRCodeEdit'
        channels={channels}
        qrPosters={qrPosters}
        getAllQrPosterExternal={getAllQrPosterExternal}
        onDataQRToWidget={onDataQRToWidget}
      />
    }
  ]

  const body = (
    <div className={'ww-tabs-container'}>
      <div className={'ww-tabs-buttons'}>
        {tabs.map((it, idx) => (
          <div key={idx}>
            <div className={`ww-tab-button ${currentTab === idx && 'active'}`} onClick={() => handleCurrentTab(idx)}>
              <span className='ww-tab-text'>{it.name}</span>
            </div>
          </div>
        ))}
        <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='close' onClick={onClose} className='close-button' />
      </div>
      <div className='ww-tabs-body animated fadeIn'>
        {tabs.length > 0 ? tabs[currentTab].body : null}
      </div>
    </div>
  )

  return (
    <ModalWrapper
      id={'modalWebWidgetWrapper'}
      body={body}
      isOpen={props.isOpen}
      toggle={onClose}
    />
  )
}

export default QRCodeCreatorModal
